import {containsCharacter} from '../Validation'

export interface PasswordQualityOptions
{
  minimumLength?: number, 
  atLeastOneNumber?: boolean, 
  atLeastOneUpperCaseLetter?: boolean, 
  atLeastOneLowerCaseLetter?: boolean, 
  requiredSpecialCharacters?: string,   // At least one of these characters is required
  restrictedCharacterOptions?: string   // None of these characters is allowed
};

// Look at a proposed password and make sure it fits the minimum requirements
//  This is not a replacement for server side validation -- this is just intended to prompt users to create good passwords
export function validatePasswordQuality(proposedPassword: string, options?: PasswordQualityOptions): boolean
{
  return 0 === passwordQualityIssues(proposedPassword, options).length;
}

// Look at a proposed password and make sure it fits the minimum requirements
//  This is not a replacement for server side validation -- this is just intended to prompt users to create good passwords
export function passwordQualityIssues(proposedPassword: string, options?: PasswordQualityOptions): string[]
{
  const qualityIssues: string[] = [];

  // Default minimumal length
  const minLength = options?.minimumLength ?? 12;
  if (proposedPassword.length < minLength)
    qualityIssues.push(`New password is too short. Expected at least ${minLength} characters`);

  // At least once number?
  if (options?.atLeastOneNumber ?? true)
    if (!/\d/.test(proposedPassword))
      qualityIssues.push("There needs to be at least one number");

  // At least one upper case character
  if (options?.atLeastOneUpperCaseLetter ?? true)
    if (!/[A-Z]/.test(proposedPassword))
      qualityIssues.push("There needs to be at least one upper case letter");

  // At least one lower case character
  if (options?.atLeastOneLowerCaseLetter ?? true)
    if (!/[a-z]/.test(proposedPassword))
      qualityIssues.push("There needs to be at least one lower case letter");

  // Check if at least one special character exists
  const specialCharacterDomain = options?.requiredSpecialCharacters ?? "~!@#$%^*()_-+={}[]:;<>?/ &";
  if (!containsCharacter(proposedPassword, specialCharacterDomain))
    qualityIssues.push(`There needs to be at least one special case character: ${specialCharacterDomain}`);

  // Check if a restricted character exists
  const restrictedCharacters = options?.restrictedCharacterOptions ?? "";
  if (restrictedCharacters.length > 0)
  {
    for(const restrictedCharacter of restrictedCharacters.split(""))
    {
      if (proposedPassword.indexOf(restrictedCharacter) > -1)
      {
        qualityIssues.push(`Restricted character not allowed: ${restrictedCharacter}`);
      }
    }
  }

  return qualityIssues;
}